import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { agriTourismTags } from "@/mocks/siteData";

export default function AgriTourismSection() {
  return (
    <section className="sun-glaze bg-primary-900 py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-40"></div>
      <div className="relative w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
                The Idea
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl leading-tight text-background-50 font-semibold">
              What Is Agri Tourism?
            </h2>
            <p className="mt-6 text-base md:text-lg text-background-200 leading-relaxed">
              Agri Tourism brings visitors closer to agriculture and rural communities through
              authentic farm and village experiences.
            </p>
            <p className="mt-5 text-base md:text-lg text-background-200 leading-relaxed">
              Our experiences are designed to help people discover the land, understand farming,
              meet farmers, and experience rural India in a meaningful way.
            </p>
            <div className="mt-8 inline-flex items-center gap-3 bg-primary-800 rounded-full pl-2 pr-6 py-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-leaf-line text-lg"></i>
              </span>
              <span className="text-sm font-medium text-background-100">
                At Rythugaru, we bring together
              </span>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={120}>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
              {agriTourismTags.map((tag) => (
                <div
                  key={tag.label}
                  className="bg-primary-800/70 border border-primary-700 rounded-lg p-4 md:p-5 text-center hover:border-accent-500 hover:bg-primary-800 transition-colors"
                >
                  <span className="text-2xl md:text-3xl block">{tag.emoji}</span>
                  <span className="block text-xs md:text-sm font-medium text-background-100 mt-3">
                    {tag.label}
                  </span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}